import React, { useState, useEffect, useMemo } from "react";
import "./OptionChain.css";
import { CiSearch } from "react-icons/ci";
import { usePcr } from "../../context/PcrContext";
import { FaSpinner } from "react-icons/fa6";
import MaxPainChart from "../MaxPainChart/MaxPainChart";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { useStockName } from "../../context/StockNameContext";
import { FiRefreshCw } from "react-icons/fi";

const OptionChain = () => {
  const [selectOption, setSelectOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedExpiry, setSelectedExpiry] = useState("");
  const [selectedStrike, setSelectedStrike] = useState("");
  const [timeoutError, setTimeoutError] = useState(false);
  const [showNoDataError, setShowNoDataError] = useState(false);
  const [fetchTriggered, setFetchTriggered] = useState(false);

  //   const [triggeredSymbol, setTriggeredSymbol] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeSymbol, setActiveSymbol] = useState(null);
  const [lastUpdated, setLastUpdated] = useState("");
  const [lastFetchType, setLastFetchType] = useState(null); //refresh data
  const { fetchStock, stockData, error } = useStockName();
  const [selectDropdown, setSelectDropdown] = useState(false);
  const getPlaceholder = () => {
    if (window.matchMedia("(max-width: 600px)").matches) {
      return "Search";
    }
    return "Search Symbol";
  };
  const [placeholder, setPlaceholder] = useState(getPlaceholder());
  useEffect(() => {
    const updateText = () => setPlaceholder(getPlaceholder());
    window.addEventListener("resize", updateText);
    return () => window.removeEventListener("resize", updateText);
  }, []);
  console.log("Error is ", error);
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };

  const { pcrStore, loadData, loadIndexData } = usePcr();
  const data = pcrStore[activeSymbol];
  // if (!data.success) {
  //   setError(data.response);
  // }
  console.log("Error", error);
  const expiryDates = data?.records?.expiryDates;

  // 1) Compute nearest expiry from list
  const nearestExpiry = useMemo(
    () => getNearestExpiry(expiryDates),
    [expiryDates],
  );

  // 2) Active expiry = user selected OR nearest by default
  const activeExpiry = selectedExpiry || nearestExpiry;

  //   const data = pcrStore[triggeredSymbol];

  const nseIndices = [
    "NIFTY",
    "BANKNIFTY",
    "FINNIFTY",
    "MIDCPNIFTY",
    "NIFTYIT",
    "NIFTYAUTO",
    "NIFTYPHARMA",
    "NIFTYMETAL",
    "NIFTYFMCG",
    "NIFTYREALTY",
    "NIFTYMEDIA",
    "NIFTYENERGY",
  ];

  const handleSelectChange = async (e) => {
    const value = e.target.value;
    setLoading(true);
    setSelectDropdown(true);
    setSelectOption(value);
    setActiveSymbol(value);
    setFetchTriggered(true);
    setSearchText("");
    setLastFetchType("index");
    await loadIndexData(value);
    setLoading(false);
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter" && searchText.trim()) {
      setLoading(true);
      const formatted = searchText.trim().toUpperCase();
      setFetchTriggered(true);
      setSelectedExpiry("");
      setSelectedStrike("");
      setSelectDropdown(false);
      setSelectOption("");
      setActiveSymbol(formatted);
      setLastFetchType("search");
      await loadData(formatted);
      await fetchStock(formatted);

      //   await loadData(activeSymbol);
      setLoading(false);
      setSearchText("");
    }
  };
  const handleExpiryChange = (e) => {
    setSelectedExpiry(e.target.value);
    setSelectedStrike("");
    setSelectDropdown(false);
  };

  const handleStrikeChange = (e) => {
    setSelectedStrike(e.target.value);
    setSelectedExpiry("");
    setSelectDropdown(false);
  };

  // useEffect(() => {
  //   if (!activeSymbol) return;
  //   setShowNoDataError(false);
  //   // if (!data) {
  //   setLoading(true);
  //   loadData(activeSymbol);
  //   fetchStock(activeSymbol);
  //   setLastUpdated(formatTimestamp());
  //   // }
  //   // 30 sec fail timeout
  //   const timer = setTimeout(() => {
  //     if (!pcrStore[activeSymbol]) {
  //       setTimeoutError(true);
  //       setLoading(false);
  //     }
  //   }, 30000);

  //   return () => clearTimeout(timer);
  //   const timer1 = setTimeout(() => {
  //     if (!filteredOptions?.length) setShowNoDataError(true);
  //     setLoading(false);
  //   }, 6000);

  //   return () => clearTimeout(timer1);
  // }, [activeSymbol]);
  // useEffect(() => {
  //   if (!activeSymbol) return;

  //   setShowNoDataError(false);
  //   setLoading(true);

  //   loadData(activeSymbol);
  //   fetchStock(activeSymbol);
  //   setLastUpdated(formatTimestamp());

  //   const timer = setTimeout(() => {
  //     if (!pcrStore[activeSymbol]) {
  //       setTimeoutError(true);
  //       setLoading(false);
  //     }
  //   }, 30000);

  //   const timer1 = setTimeout(() => {
  //     if (!filteredOptions?.length) {
  //       setShowNoDataError(true);
  //     }
  //     setLoading(false);
  //   }, 6000);

  //   return () => {
  //     clearTimeout(timer);
  //     clearTimeout(timer1);
  //   };
  // }, [activeSymbol]);
  useEffect(() => {
    if (!activeSymbol) return;

    setShowNoDataError(false);
    setTimeoutError(false);
    setLoading(true);

    loadData(activeSymbol);
    fetchStock(activeSymbol);
    setLastUpdated(formatTimestamp());

    // 30 sec timeout if nothing loads
    const failTimer = setTimeout(() => {
      setTimeoutError(true);
      setLoading(false);
    }, 30000);

    return () => clearTimeout(failTimer);
  }, [activeSymbol]);

  console.log("Data", data);

  //   const options = data?.filtered?.data;
  const options = data?.records?.data;
  console.log("Options", options);

  function getNearestExpiry(expiryDates) {
    if (!expiryDates || expiryDates.length === 0) return "";

    const today = new Date();

    const futureDates = expiryDates
      .map((date) => ({
        raw: date,
        parsed: new Date(date), // JS uses this only for comparison
      }))
      .filter((d) => d.parsed >= today)
      .sort((a, b) => a.parsed - b.parsed);

    // If no future date found (all past), fallback to first in list
    return futureDates.length > 0 ? futureDates[0].raw : expiryDates[0];
  }
  //
  // const expiryDates = data?.records?.expiryDates;

  // 1) Compute nearest expiry from list
  const nearestExpiryDates = useMemo(
    () => getNearestExpiry(expiryDates),
    [expiryDates],
  );

  // const activeExpiry = selectedExpiry || nearestExpiryDates;

  const filteredOptions = useMemo(() => {
    if (!options) return [];

    if (selectedStrike) {
      const strikeNum = Number(selectedStrike);
      return options.filter((item) => item.strikePrice === strikeNum);
    }

    if (activeExpiry) {
      return options.filter((item) => item.expiryDate === activeExpiry);
    }

    // Fallback
    return options;
  }, [options, selectedExpiry, selectedStrike, activeExpiry]);
  const optionsForExpiry = useMemo(
    () => (options || []).filter((item) => item.expiryDate === activeExpiry),
    [options, activeExpiry],
  );

  console.log("filteredoptions", filteredOptions);
  const ce = data?.filtered?.CE;
  const pe = data?.filtered?.PE;
  const underlying = data?.records?.underlyingValue;
  // const expiryDates = data?.records?.expiryDates;
  const strikePrices = data?.records?.strikePrices;
  const nseCodeData = data?.filtered?.data;
  const nseCode = nseCodeData?.[0]?.PE?.underlying;
  const underlyingValue = nseCodeData?.[0]?.PE?.underlyingValue;
  console.log("Nsecode", nseCode);
  //   console.log("CE", ce);

  console.log("Expiry Dates", expiryDates);
  console.log("Underlyingvalue", underlying);
  console.log("Strike Prices", strikePrices);
  // const nearestExpiry = expiryDates?.[0];
  const ceMaxOI =
    options && Math.max(...options?.map((item) => item.CE?.openInterest || 0));

  const peMaxOI =
    options && Math.max(...options.map((item) => item.PE?.openInterest || 0));
  console.log("CEMAX", ceMaxOI);
  console.log("peMAx", peMaxOI);
  const ceOI =
    options &&
    options
      .filter((item) => item?.CE)
      .reduce((sum, item) => sum + (item?.CE?.openInterest || 0), 0);
  const peOI =
    options &&
    options
      .filter((item) => item.PE)
      .reduce((sum, item) => sum + (item.PE.openInterest || 0), 0);
  const pcr = (peOI / ceOI).toFixed(2);

  console.log("Pcr", pcr);
  const totCEOI = data?.filtered?.CE.totOI;
  console.log("TotalOI", totCEOI);
  const toPEOI = data?.filtered?.PE.totOI;
  console.log("TOTaloi for pe", toPEOI);

  //   function calculateMaxPain(options, underlying) {
  //     const strikes = options?.map((item) => item.strikePrice);
  //     let minPain = Infinity;
  //     let maxPainStrike = null;

  //     strikes?.forEach((strike) => {
  //       let totalPain = 0;

  //       options?.forEach((item) => {
  //         const ceOI = item.CE?.openInterest || 0;
  //         const peOI = item.PE?.openInterest || 0;
  //         const s = item.strikePrice;

  //         // Call Pain: if expiry at 'strike', calls below strike are ITM
  //         if (strike > s) {
  //           totalPain += (strike - s) * ceOI;
  //         }

  //         // Put Pain: if expiry at 'strike', puts above strike are ITM
  //         if (strike < s) {
  //           totalPain += (s - strike) * peOI;
  //         }
  //       });

  //       if (totalPain < minPain) {
  //         minPain = totalPain;
  //         maxPainStrike = strike;
  //       }
  //     });

  //     return maxPainStrike;
  //   }

  //mathematical maxpain
  // function calculateMaxPain(options, underlying) {
  //   if (!options?.length) return null;

  //   // Filter out dead strikes (0 OI)
  //   const validOptions = options.filter(
  //     (item) =>
  //       (item.CE?.openInterest || 0) > 0 || (item.PE?.openInterest || 0) > 0
  //   );

  //   if (!validOptions.length) return null;

  //   // Unique sorted strike prices
  //   const strikes = [...new Set(validOptions.map((i) => i.strikePrice))].sort(
  //     (a, b) => a - b
  //   );

  //   let minPain = Infinity;
  //   let maxPainStrike = null;

  //   strikes.forEach((strike) => {
  //     let totalPain = 0;

  //     validOptions.forEach((item) => {
  //       const ceOI = item.CE?.openInterest || 0;
  //       const peOI = item.PE?.openInterest || 0;
  //       const s = item.strikePrice;

  //       // CALL Pain
  //       if (strike > s) totalPain += (strike - s) * ceOI;

  //       // PUT Pain
  //       if (strike < s) totalPain += (s - strike) * peOI;
  //     });

  //     if (totalPain < minPain) {
  //       minPain = totalPain;
  //       maxPainStrike = strike;
  //     }
  //   });

  //   return Math.round(maxPainStrike); // rounded for safety
  // }
  //new maxpain matching closest also
  function calculateMaxPain(options, underlying) {
    if (!options?.length) return null;

    // Filter out strikes having zero OI
    const validOptions = options.filter(
      (item) =>
        (item.CE?.openInterest || 0) > 0 || (item.PE?.openInterest || 0) > 0,
    );

    if (!validOptions.length) return null;

    // Extract sorted strike prices
    const strikes = [...new Set(validOptions.map((i) => i.strikePrice))].sort(
      (a, b) => a - b,
    );

    let minPain = Infinity;
    let maxPainStrike = null;

    // Calculate pain for each available strike
    strikes.forEach((strike) => {
      let totalPain = 0;

      validOptions.forEach((item) => {
        const ceOI = item.CE?.openInterest || 0;
        const peOI = item.PE?.openInterest || 0;
        const s = item.strikePrice;

        if (strike > s) totalPain += (strike - s) * ceOI;
        if (strike < s) totalPain += (s - strike) * peOI;
      });

      if (totalPain < minPain) {
        minPain = totalPain;
        maxPainStrike = strike;
      }
    });

    // Step 2: Round value (same as before)
    const roundedMaxPain = Math.round(maxPainStrike);

    // Step 3: If rounded value doesn't exist, map to closest available strike
    if (!strikes.includes(roundedMaxPain)) {
      const closestStrike = strikes.reduce((prev, curr) =>
        Math.abs(curr - roundedMaxPain) < Math.abs(prev - roundedMaxPain)
          ? curr
          : prev,
      );

      return closestStrike;
    }

    return roundedMaxPain;
  }

  function calculateNiftyInvestMaxPain(options, underlying) {
    if (!options?.length) return null;

    // 0️⃣ Determine strike step size (50, 100, etc)
    const strikeStep = options[1].strikePrice - options[0].strikePrice;

    // 1️⃣ Keep only ATM ± 10 strikes
    const filtered = options.filter(
      (item) => Math.abs(item.strikePrice - underlying) <= strikeStep * 10,
    );

    // 2️⃣ Remove dead/no liquidity strikes
    const liquidityFiltered = filtered.filter(
      (item) =>
        (item.CE?.openInterest || 0) > 200 ||
        (item.PE?.openInterest || 0) > 200,
    );

    // 3️⃣ Create smoothed effective OI (NiftyInvest logic shortcut)
    const processed = liquidityFiltered.map((item) => ({
      strikePrice: item.strikePrice,
      ceOI:
        (item.CE?.openInterest || 0) +
        0.5 * (item.CE?.changeinOpenInterest || 0),
      peOI:
        (item.PE?.openInterest || 0) +
        0.5 * (item.PE?.changeinOpenInterest || 0),
    }));

    // 4️⃣ Calculate Max Pain using effective OI
    const strikes = processed.map((i) => i.strikePrice);

    let minPain = Infinity;
    let maxPainStrike = null;

    strikes.forEach((strike) => {
      let pain = 0;

      processed.forEach((item) => {
        const s = item.strikePrice;

        // CALL pain: calls below strike are ITM
        if (strike > s) pain += (strike - s) * item.ceOI;

        // PUT pain: puts above strike are ITM
        if (strike < s) pain += (s - strike) * item.peOI;
      });

      if (pain < minPain) {
        minPain = pain;
        maxPainStrike = strike;
      }
    });

    // 5️⃣ Round to nearest strike step (like NiftyInvest)
    return Math.round(maxPainStrike / strikeStep) * strikeStep;
  }
  //format number function
  const formatNumber = (num) => {
    if (num % 1 !== 0) {
      return num?.toFixed(2);
    }
    return num;
  };
  //built up function
  function getBuiltUp(changeInOI, priceChange) {
    if (changeInOI > 0 && priceChange > 0) return "LB"; // Long Built-Up
    if (changeInOI > 0 && priceChange < 0) return "SB"; // Short Built-Up
    if (changeInOI < 0 && priceChange > 0) return "SC"; // Short Covering
    if (changeInOI < 0 && priceChange < 0) return "LW"; // Long Unwinding
    return "-";
  }
  const getBuiltUpMeta = (code) => {
    switch (code) {
      case "LB":
        return {
          label: "Long Built-Up (OI ↑ & Price ↑)",
          color: "#008A3E",
          bg: "#d4f7e6",
        };

      case "SB":
        return {
          label: "Short Built-Up (OI ↑ & Price ↓)",
          color: "#C53030",
          bg: "#ffd4d4",
        };

      case "SC":
        return {
          label: "Short Covering (OI ↓ & Price ↑)",
          color: "#0E65F0",
          bg: "#dbe8ff",
        };

      case "LW":
        return {
          label: "Long Unwinding (OI ↓ & Price ↓)",
          color: "#c46a00",
          bg: "#ffe8c7",
        };

      default:
        return {
          label: "No Signal",
          color: "#ffffff",
          bg: "#1f2937",
        };
    }
  };
  //built up color
  //   function getBuiltUpColor(code) {
  //     switch (code) {
  //       case "LB":
  //         return "green";
  //       case "SB":
  //         return "red";
  //       case "SC":
  //         return "blue";
  //       case "LW":
  //         return "orange";
  //       default:
  //         return "black";
  //     }
  //   }

  function getBuiltUpColor(code) {
    switch (code) {
      case "LB":
        return "#008A3E";
      case "SB":
        return "#C53030";
      case "SC":
        return "#C53030";
      case "LW":
        return "#C68A14";
      default:
        return "#fbbf24";
    }
  }

  const finalPain = calculateNiftyInvestMaxPain(options, underlying);
  console.log("FinalMaxpai", finalPain);

  const maxPain = calculateMaxPain(optionsForExpiry, underlying);

  const maxPainRow = optionsForExpiry?.filter(
    (item) => item.strikePrice === maxPain,
  );
  console.log("maxPainRow", maxPainRow);
  // const strikeStep = options[1]?.strikePrice - options[0]?.strikePrice;
  const strikes = [...new Set(options?.map((item) => item.strikePrice))].sort(
    (a, b) => a - b,
  );

  const strikeStep = strikes.length > 1 ? strikes[1] - strikes[0] : 0;

  const difference = Math.abs(underlying - maxPain);

  let sentimentTextColor = "black"; // default

  if (difference <= strikeStep) {
    sentimentTextColor = "#e6e6e6"; // neutral
  } else if (underlying < maxPain) {
    sentimentTextColor = "#2fd18a"; // bullish -> green text
  } else if (underlying > maxPain) {
    sentimentTextColor = "#ff4d4d"; // bearish -> red text
  }
  const getPCRSentiment = (pcr) => {
    let sentiment;
    let color; // Text color (dark shade)
    let bgColor; // Background (light shade)

    if (pcr < 0.7) {
      sentiment = "Bearish";
      color = "#C53030"; // Strong red
      bgColor = "#ffd4d4"; // Light red background
    } else if (pcr >= 0.7 && pcr <= 1.0) {
      sentiment = "Neutral";
      color = "#fbbf24";
      bgColor = "#EAEAEA"; // Light gray background
    } else if (pcr > 1.0 && pcr <= 1.3) {
      sentiment = "Bullish";
      color = "#008A3E"; // Dark green
      bgColor = "#d4f7e6"; // Light green background
    } else {
      sentiment = "Overly Bullish (Contrarian Risk)";
      color = "#856404"; // Golden/Brown text
      bgColor = "#FFF3CD"; // Soft yellow background
    }

    return { sentiment, color, bgColor };
  };

  const pcrSentimentColor = getPCRSentiment(pcr);
  console.log("PcrSentiment", pcrSentimentColor);
  const ceMaxRow = maxPainRow?.[0]?.CE;
  const peMaxRow = maxPainRow?.[0]?.PE;
  const ceMaxRowBuiltUp = getBuiltUp(
    ceMaxRow?.changeinOpenInterest,
    ceMaxRow?.change,
  );
  console.log("ceMaxRowBuiltup", ceMaxRowBuiltUp);
  const peMaxRowBuiltUp = getBuiltUp(
    peMaxRow?.changeinOpenInterest,
    peMaxRow?.change,
  );
  console.log("peMaxRowBuiltup", peMaxRowBuiltUp);
  console.log("ceMaxRow", ceMaxRow);
  console.log("peMaxRow", peMaxRow);

  const builtUpStyles = (signal) => {
    switch (signal) {
      case "LB":
        return { bg: "#d4f7e6", color: "#008A3E" };
      case "SB":
        return { bg: "#ffd4d4", color: "#C53030" };
      case "SC":
        return { bg: "#dce8ff", color: "#0047FF" };
      case "LW":
        return { bg: "#ffeac7", color: "#C68A14" };
      default:
        return { bg: "#f2f2f2", color: "#444" };
    }
  };
  const builtUpStyleCE = builtUpStyles(ceMaxRowBuiltUp);
  const builtUpStylePE = builtUpStyles(peMaxRowBuiltUp);

  const builtUpSentimentCE = getBuiltUpMeta(ceMaxRowBuiltUp);
  const builtUpSentimentPE = getBuiltUpMeta(peMaxRowBuiltUp);
  console.log("BuildupSeniCE", builtUpSentimentCE);
  console.log("buildeSentiPE", builtUpSentimentPE);

  //handle refresh function
  const handleRefresh = async () => {
    if (!activeSymbol) return;

    setLoading(true);

    if (lastFetchType === "index") {
      await loadIndexData(activeSymbol);
    } else if (lastFetchType === "search") {
      await loadData(activeSymbol);
    }

    setLastUpdated(formatTimestamp());
    setLoading(false);
  };

  //select expory date
  useEffect(() => {
    console.log("💾 Latest StockData:", stockData);
  }, [stockData]);

  console.log("Stock data from Context", stockData);
  const companyName = stockData?.name;
  console.log("CompanyName", companyName);
  useEffect(() => {
    if (!fetchTriggered) return;
    if (loading) return;

    if (filteredOptions?.length > 0) {
      setShowNoDataError(false);
      return;
    }

    // No data -> start controlled timer
    const noDataTimer = setTimeout(() => {
      if (!filteredOptions?.length) setShowNoDataError(true);
    }, 2000); // shorter detection time

    return () => clearTimeout(noDataTimer);
  }, [filteredOptions, loading]);

  return (
    <>
      <div className="option-chain">
        <div className="option-menu nse-layout">
          {/* Dropdown */}

          <div className="option-chain-head">
            <div className="select-option dropdown">
              <label>Contracts</label>
              <select
                onChange={handleSelectChange}
                value={selectOption || ""}
                style={{
                  // backgroundColor: "#0f1720",
                  // color: "white",
                  // fontWeight: 700,
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                }}
              >
                <option value="">Select</option>
                {nseIndices.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <span>OR</span>

            <div className="search-option dropdown">
              <label>Search Symbol</label>
              <div
                className="search-option-input"
                style={{
                  borderRadius: "12px",

                  display: "flex",
                  alignItems: "center",
                  padding: "0px 10px",

                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                }}
              >
                <input
                  type="text"
                  placeholder={placeholder}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  className="search-option-chain"
                  style={{
                    padding: "14px",
                    width: "150px",

                    borderRadius: "20px",
                    border: "none",
                    outline: "none",
                  }}
                />
                <span className="search-span">
                  <CiSearch />
                </span>
              </div>
            </div>
          </div>

          <div className="option-chain-head">
            <div className="select-option dropdown">
              <label>Expiry Dates</label>
              <select onChange={handleExpiryChange} value={activeExpiry || ""}>
                {expiryDates?.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <span>OR</span>
            <div className="select-option dropdown">
              <label>Strike</label>
              <select onChange={handleStrikeChange} value={selectOption || ""}>
                <option value="">Select</option>
                <option
                  value=""
                  onClick={() => {
                    setSelectedExpiry("");
                    setSelectedStrike("");
                  }}
                >
                  Default
                </option>
                {strikePrices?.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div className="last-updated-head">
              {lastUpdated && <span>As on {lastUpdated}</span>}
              <FiRefreshCw
                onClick={handleRefresh}
                size={18}
                style={{
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
                onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
              />
            </div>
          </div>

          <div></div>
        </div>
      </div>

      {loading ? (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      ) : showNoDataError ? (
        <div
          style={{
            padding: "10px",
            color: "white",
            borderRadius: "6px",
            marginBottom: "12px",
            textAlign: "center",
            fontWeight: "600",
          }}
        >
          F & O data unavailable/Ticker not found!
        </div>
      ) : (
        filteredOptions?.length > 0 && (
          <div>
            <div className="last-updated-head">
              {lastUpdated && <span>As on {lastUpdated}</span>}
              <FiRefreshCw
                onClick={handleRefresh}
                size={18}
                style={{
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
                onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
              />
            </div>

            <div className="pcr-grid option-grid">
              {/* <div
                style={{
                  background: "#0f1720",
                  padding: "18px 22px",
                  width: "260px",
                  borderRadius: "12px",
                  //   border: "1px solid #d8d8d8",
                  textAlign: "center",
                  boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                }}
              >
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "white",
                    marginBottom: "10px",
                  }}
                >
                  Symbol {nseCode}
                </h3>

                <div
                  style={{
                    boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    color: "white",
                    alignItems: "center",
                  }}
                >
                  Max Pain- {maxPain}
                </div>

                <div
                  style={{
                    marginTop: "15px",

                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                    color: "white",
                  }}
                >
                  Underlying Price - {underlyingValue}
                </div>

                <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",

                    marginTop: "1rem",
                    boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                    backgroundColor: pcrSentimentColor.bgColor,
                    color: pcrSentimentColor.color,

                    // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  PCR - {pcr}
                </div>
                <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",

                    marginTop: "1rem",
                    boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                    backgroundColor: pcrSentimentColor.bgColor,
                    color: pcrSentimentColor.color,

                    // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  Signal - {pcrSentimentColor.sentiment}
                </div>
              </div> */}
              {/* <div
                style={{
                  background: "#0f1720",
                  padding: "24px 22px",
                  width: "260px",
                  borderRadius: "16px",
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(0,0,0,0.35)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "800",
                    color: "white",
                    margin: 0,
                    letterSpacing: "0.5px",
                  }}
                >
                  Symbol {nseCode}
                </h3>

                <div
                  style={{
                    background: "#111e29",
                    padding: "12px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "15px",
                    color: "#ffffff",
                    boxShadow: "inset 0px 0px 10px rgba(255,255,255,0.08)",
                  }}
                >
                  Max Pain - {maxPain}
                </div>

                <div
                  style={{
                    background: "#111e29",
                    padding: "12px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "15px",
                    color: "#ffffff",
                    boxShadow: "inset 0px 0px 10px rgba(255,255,255,0.08)",
                  }}
                >
                  Underlying Price - {underlyingValue}
                </div>

                <div
                  style={{
                    padding: "12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "16px",
                    color: pcrSentimentColor.color,
                    backgroundColor: pcrSentimentColor.bgColor,
                    boxShadow: "0px 2px 5px rgba(255,255,255,0.1)",
                  }}
                >
                  PCR - {pcr}
                </div>

                <div
                  style={{
                    padding: "12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "16px",
                    color: pcrSentimentColor.color,
                    backgroundColor: pcrSentimentColor.bgColor,
                    boxShadow: "0px 2px 5px rgba(255,255,255,0.1)",
                  }}
                >
                  Signal - {pcrSentimentColor.sentiment}
                </div>
              </div> */}
              <div
                className="grid-1"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  // width: "260px",
                  color: "white",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  textAlign: "left",
                  marginTop: "10px",
                  // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                }}
              >
                {!selectDropdown && <p>Company Name - {companyName}</p>}
                <p>
                  {selectDropdown ? "Contract" : "Stock Symbol"} - {nseCode}
                </p>

                <p>
                  Max Pain:{" "}
                  <span style={{ fontWeight: "700", color: "#00e1b1" }}>
                    {maxPain}
                  </span>
                </p>

                <p>
                  Underlying Price:
                  <span style={{ fontWeight: "700", color: "#00b3ff" }}>
                    {" "}
                    {underlyingValue}
                  </span>
                </p>

                <p>
                  PCR:{" "}
                  <strong style={{ color: pcrSentimentColor.color }}>
                    {pcr}
                  </strong>
                </p>

                <p>
                  Signal:{" "}
                  <strong style={{ color: pcrSentimentColor.color }}>
                    {" "}
                    {pcrSentimentColor.sentiment}
                  </strong>
                </p>
              </div>

              <div className="grid built-up-grid">
                <h1
                  style={{
                    fontWeight: "800",
                    textAlign: "left",
                  }}
                >
                  Built Up Abbreviation and Colors
                </h1>
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,

                    textAlign: "left",
                  }}
                >
                  <li style={{ color: "#008A3E", marginBottom: "6px" }}>
                    <strong>LB</strong> – Long Built-Up (OI ↑ & Price ↑)
                  </li>

                  <li style={{ color: "#C53030", marginBottom: "6px" }}>
                    <strong>SB</strong> – Short Built-Up (OI ↑ & Price ↓)
                  </li>

                  <li style={{ color: "#0047FF", marginBottom: "6px" }}>
                    <strong>SC</strong> – Short Covering (OI ↓ & Price ↑)
                  </li>

                  <li style={{ color: "#C68A14", marginBottom: "6px" }}>
                    <strong>LW</strong> – Long Unwinding (OI ↓ & Price ↓)
                  </li>
                </ul>
              </div>

              <div className="ce-pe">
                <div className="ce-pe1">
                  <div>
                    <h3>Ltp ({maxPain} CE)</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          ceMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",

                        color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {ceMaxRow?.lastPrice ?? "-"}{" "}
                      {ceMaxRow?.change >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {ceMaxRow?.change.toFixed(2) + "%" ?? "-"}
                      </span>
                    </div>
                  </div>

                  <div className="sub-grid">
                    <h3>Open Interest</h3>
                    <div
                      className="ce-pe2"
                      style={{
                        // marginTop: "15px",
                        background:
                          ceMaxRow?.pchangeinOpenInterest >= 0
                            ? "#d4f7e6"
                            : "#ffd4d4",

                        color:
                          ceMaxRow?.pchangeinOpenInterest >= 0
                            ? "#008A3E"
                            : "#C53030",
                      }}
                    >
                      {formatNumber(ceMaxRow?.openInterest) ?? "-"}{" "}
                      {ceMaxRow?.pchangeinOpenInterest >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {ceMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ??
                          "-"}
                      </span>
                    </div>
                  </div>
                  <div className="sub-grid">
                    <h3>Built Up</h3>
                    <div
                      className="ce-pe2"
                      style={{
                        // padding: "10px 12px",
                        // borderRadius: "8px",
                        // fontWeight: "700",
                        // fontSize: "15px",
                        // display: "flex",
                        // gap: "10px",
                        // justifyContent: "center",
                        // alignItems: "center",
                        backgroundColor: builtUpStyleCE.bg,
                        color: builtUpStyleCE.color,
                        // marginTop: "1rem",
                        // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {ceMaxRowBuiltUp}
                    </div>
                  </div>

                  {/* <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",

                    marginTop: "1rem",
                    backgroundColor: builtUpSentimentCE.bg,
                    color: builtUpSentimentCE.color,

                    // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {builtUpSentimentCE?.label ?? "-"}
                </div> */}
                </div>
                <div className="ce-pe1">
                  <div>
                    <h3
                    // style={{
                    //   fontSize: "18px",
                    //   fontWeight: "700",
                    //   color: "white",
                    //   marginBottom: "10px",
                    // }}
                    >
                      Ltp ({maxPain} PE)
                    </h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          peMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                        // padding: "10px 12px",
                        // borderRadius: "8px",
                        // fontWeight: "700",
                        // fontSize: "15px",
                        // display: "flex",
                        // gap: "10px",
                        // justifyContent: "center",
                        // alignItems: "center",
                        color: peMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {peMaxRow?.lastPrice ?? "-"}{" "}
                      {peMaxRow?.change >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {peMaxRow?.change.toFixed(2) + "%" ?? "-"}
                      </span>
                    </div>
                  </div>

                  {/* OI box */}
                  <div className="sub-grid">
                    <h3

                    // style={{
                    //   fontSize: "18px",
                    //   fontWeight: "700",
                    //   color: "white",
                    //   marginBottom: "10px",
                    // }}
                    >
                      Open Interest
                    </h3>
                    <div
                      className="ce-pe2"
                      style={{
                        // marginTop: "15px",
                        background:
                          peMaxRow?.pchangeinOpenInterest >= 0
                            ? "#d4f7e6"
                            : "#ffd4d4",
                        // padding: "10px 12px",
                        // borderRadius: "8px",
                        // fontWeight: "700",
                        // fontSize: "15px",
                        // display: "flex",
                        // gap: "10px",
                        // justifyContent: "center",
                        // alignItems: "center",
                        color:
                          peMaxRow?.pchangeinOpenInterest >= 0
                            ? "#008A3E"
                            : "#C53030",
                      }}
                    >
                      {formatNumber(peMaxRow?.openInterest) ?? "-"}
                      {peMaxRow?.pchangeinOpenInterest >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {peMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ??
                          "-"}
                      </span>
                    </div>
                  </div>
                  <div className="sub-grid">
                    <h3
                    // style={{
                    //   fontSize: "18px",
                    //   fontWeight: "700",
                    //   color: "white",
                    //   marginBottom: "10px",
                    // }}
                    >
                      Built Up
                    </h3>
                    <div
                      className="ce-pe2"
                      style={{
                        // padding: "10px 12px",
                        // borderRadius: "8px",
                        // fontWeight: "700",
                        // fontSize: "15px",
                        // display: "flex",
                        // gap: "10px",
                        // justifyContent: "center",
                        // alignItems: "center",
                        backgroundColor: builtUpStylePE.bg,
                        color: builtUpStylePE.color,
                        // marginTop: "1rem",
                      }}
                    >
                      {peMaxRowBuiltUp}
                    </div>
                  </div>

                  {/* <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: builtUpSentimentPE.bg,
                    color: builtUpSentimentPE.color,
                    marginTop: "1rem",
                  }}
                >
                  {builtUpSentimentPE?.label ?? "-"}
                </div> */}
                </div>
              </div>
              <div className="grid built-up-grid built-mobile">
                <h1
                // style={{
                //   color: "white",
                //   fontWeight: "800",
                //   textAlign: "left",
                // }}
                >
                  {" "}
                  Built Up Abbreviation and Colors
                </h1>
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,
                    // marginTop: "20px",
                    textAlign: "left",
                  }}
                >
                  <li style={{ color: "#008A3E", marginBottom: "6px" }}>
                    <strong>LB</strong> – Long Built-Up (OI ↑ & Price ↑)
                  </li>

                  <li style={{ color: "#C53030", marginBottom: "6px" }}>
                    <strong>SB</strong> – Short Built-Up (OI ↑ & Price ↓)
                  </li>

                  <li style={{ color: "#0047FF", marginBottom: "6px" }}>
                    <strong>SC</strong> – Short Covering (OI ↓ & Price ↑)
                  </li>

                  <li style={{ color: "#C68A14", marginBottom: "6px" }}>
                    <strong>LW</strong> – Long Unwinding (OI ↓ & Price ↓)
                  </li>
                </ul>
              </div>
              {/* <div
                className="grid"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "#0f1720",
                  padding: "18px 22px",
                 
                  borderRadius: "12px",
                 
                  textAlign: "center",
                  boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                }}
              >
                <div>
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Ltp ({maxPain} CE)
                  </h3>

                  <div
                    style={{
                      background: ceMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                    }}
                  >
                    {ceMaxRow?.lastPrice ?? "-"}{" "}
                    {ceMaxRow?.change >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {ceMaxRow?.change.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>

                <div className="sub-grid">
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Open Interest
                  </h3>
                  <div
                    style={{
                     
                      background:
                        ceMaxRow?.pchangeinOpenInterest >= 0
                          ? "#d4f7e6"
                          : "#ffd4d4",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      color:
                        ceMaxRow?.pchangeinOpenInterest >= 0
                          ? "#008A3E"
                          : "#C53030",
                    }}
                  >
                    {formatNumber(ceMaxRow?.openInterest) ?? "-"}{" "}
                    {ceMaxRow?.pchangeinOpenInterest >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {ceMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>
                <div className="sub-grid">
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Built Up
                  </h3>
                  <div
                    style={{
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: builtUpStyleCE.bg,
                      color: builtUpStyleCE.color,
                      // marginTop: "1rem",
                      // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                    }}
                  >
                    {ceMaxRowBuiltUp}
                  </div>
                </div>

              </div> */}
              {/* Call box */}
              <div className="grid call-grid">
                <div>
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Ltp ({maxPain} PE)
                  </h3>

                  <div
                    style={{
                      background: peMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      color: peMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                    }}
                  >
                    {peMaxRow?.lastPrice ?? "-"}{" "}
                    {peMaxRow?.change >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.change.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>

                {/* OI box */}
                <div className="sub-grid">
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Open Interest
                  </h3>
                  <div
                    style={{
                      // marginTop: "15px",
                      background:
                        peMaxRow?.pchangeinOpenInterest >= 0
                          ? "#d4f7e6"
                          : "#ffd4d4",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      color:
                        peMaxRow?.pchangeinOpenInterest >= 0
                          ? "#008A3E"
                          : "#C53030",
                    }}
                  >
                    {formatNumber(peMaxRow?.openInterest) ?? "-"}
                    {peMaxRow?.pchangeinOpenInterest >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>
                <div className="sub-grid">
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Built Up
                  </h3>
                  <div
                    style={{
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: builtUpStylePE.bg,
                      color: builtUpStylePE.color,
                      // marginTop: "1rem",
                    }}
                  >
                    {peMaxRowBuiltUp}
                  </div>
                </div>

                {/* <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: builtUpSentimentPE.bg,
                    color: builtUpSentimentPE.color,
                    marginTop: "1rem",
                  }}
                >
                  {builtUpSentimentPE?.label ?? "-"}
                </div> */}
              </div>

              {/* PUT BOX */}
              <div
                className="grid call-grid"
                // style={{
                //   display: "flex",
                //   justifyContent: "space-between",
                //   alignItems: "center",
                //   background: "#0f1720",
                //   padding: "18px 22px",

                //   borderRadius: "12px",

                //   textAlign: "center",
                //   boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                // }}
              >
                <div>
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Ltp ({maxPain} PE)
                  </h3>

                  <div
                    style={{
                      background: peMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      color: peMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                    }}
                  >
                    {peMaxRow?.lastPrice ?? "-"}{" "}
                    {peMaxRow?.change >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.change.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>

                {/* OI box */}
                <div className="sub-grid">
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Open Interest
                  </h3>
                  <div
                    style={{
                      // marginTop: "15px",
                      background:
                        peMaxRow?.pchangeinOpenInterest >= 0
                          ? "#d4f7e6"
                          : "#ffd4d4",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      color:
                        peMaxRow?.pchangeinOpenInterest >= 0
                          ? "#008A3E"
                          : "#C53030",
                    }}
                  >
                    {formatNumber(peMaxRow?.openInterest) ?? "-"}
                    {peMaxRow?.pchangeinOpenInterest >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>
                <div className="sub-grid">
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "white",
                      marginBottom: "10px",
                    }}
                  >
                    Built Up
                  </h3>
                  <div
                    style={{
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: builtUpStylePE.bg,
                      color: builtUpStylePE.color,
                      // marginTop: "1rem",
                    }}
                  >
                    {peMaxRowBuiltUp}
                  </div>
                </div>

                {/* <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: builtUpSentimentPE.bg,
                    color: builtUpSentimentPE.color,
                    marginTop: "1rem",
                  }}
                >
                  {builtUpSentimentPE?.label ?? "-"}
                </div> */}
              </div>
            </div>

            <div
              className="stock-table-container option-chain-table"
              style={{ overflowX: "auto" }}
              // -webkit-overflow-scrolling: touch;
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  margin: "20px auto",
                  maxHeight: "600px",
                  overflowX: "auto",
                  overflowY: "auto",
                  position: "relative",
                }}
                className="stock-table option-chain-tablee"
              >
                {/* <thead>
                  <tr>
                    <th>CALL OI</th>
                    <th>CALL Chg OI</th>
                    <th>CALL Vol</th>
                    <th>CALL IV</th>
                    <th>CALL LTP</th>
                    <th>CALL Chg</th>
                    <th>Strike</th>
                    <th>PUT Chg</th>
                    <th>PUT LTP</th>
                    <th>PUT IV</th>
                    <th>PUT Vol</th>
                    <th>PUT Chg OI</th>
                    <th>PUT OI</th>
                    <th>PCR</th>
                  </tr>
                </thead> */}
                <thead>
                  <tr>
                    {/* CALL HEADERS (GREEN) */}
                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      CALL OI
                    </th>
                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      CALL Chg OI
                    </th>
                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      CALL Vol
                    </th>
                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      CALL IV
                    </th>
                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      CALL LTP
                    </th>
                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      CALL Chg
                    </th>
                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      Built Up
                    </th>

                    <th
                      style={{
                        background: "#2fd18a",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      CALL PAIN
                    </th>
                    {/* STRIKE COLUMN (Neutral) */}
                    {/* <th
                      style={{
                        background: "#f3f3f3",
                        color: "#000",
                        fontWeight: 700,
                      }}
                    >
                      EXPIRY DATE
                    </th> */}
                    <th
                      style={{
                        background: "#f3f3f3",
                        color: "#000",
                        fontWeight: 700,
                      }}
                    >
                      PCR
                    </th>
                    <th
                      style={{
                        background: "#f3f3f3",
                        color: "#000",
                        fontWeight: 700,
                      }}
                    >
                      Strike
                    </th>

                    {/* PUT HEADERS (RED) */}
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      PUT Chg
                    </th>
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      PUT LTP
                    </th>
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      PUT IV
                    </th>
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      PUT Vol
                    </th>
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      PUT Chg OI
                    </th>
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      PUT OI
                    </th>
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      Built Up
                    </th>
                    <th
                      style={{
                        background: "#ff4d4d",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      PUT PAIN
                    </th>

                    {/* PCR (Neutral) */}

                    {/* <th
                      style={{
                        background: "#f3f3f3",
                        color: "#000",
                        fontWeight: 700,
                      }}
                    >
                      PAIN
                    </th> */}
                  </tr>
                </thead>

                {/* <tbody>
                  {options?.map((item, idx) => (
                  
                    <tr key={idx}>
                     
                      
                      <td>
                        <span
                          style={{
                            backgroundColor:
                              item.CE?.openInterest === ceMaxOI
                                ? "#2fd18a"
                                : "transparent",
                            fontWeight:
                              item.CE?.openInterest === ceMaxOI ? "bold" : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {item.CE?.openInterest ?? "-"}
                        </span>
                      </td>
                      <td>{item.CE?.changeinOpenInterest ?? "-"}</td>
                      <td>{item.CE?.totalTradedVolume ?? "-"}</td>
                      <td>{item.CE?.impliedVolatility ?? "-"}</td>
                      <td>{item.CE?.lastPrice ?? "-"}</td>
                      <td>{item.CE?.change.toFixed(2) ?? "-"}</td>
                      <td>
                        <strong>{item.strikePrice}</strong>
                      </td>
                      <td>{item.PE?.change.toFixed(2) ?? "-"}</td>
                      <td>{item.PE?.lastPrice ?? "-"}</td>
                      <td>{item.PE?.impliedVolatility ?? "-"}</td>
                      <td>{item.PE?.totalTradedVolume ?? "-"}</td>
                      <td>{item.PE?.changeinOpenInterest ?? "-"}</td>
                    
                      <td>
                        <span
                          style={{
                            backgroundColor:
                              item.PE?.openInterest === peMaxOI
                                ? "#ff4d4d"
                                : "transparent",
                            fontWeight:
                              item.PE?.openInterest === peMaxOI ? "bold" : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {item.CE?.openInterest ?? "-"}
                        </span>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td> {ce?.totOI}</td>
                    <td></td>
                    <td>{ce?.totVol}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{pe?.totVol}</td>
                    <td></td>
                    <td>{pe?.totOI}</td>
                  </tr>
                </tbody> */}
                <tbody>
                  {filteredOptions?.map((item, idx) => {
                    const ceOI = item.CE?.openInterest || 0;
                    const peOI = item.PE?.openInterest || 0;
                    const rowPCR = ceOI > 0 ? (peOI / ceOI).toFixed(2) : "-";
                    // pcr += rowPCR;
                    const strike = item.strikePrice;

                    // 1️⃣ Find ATM strike
                    const isATM =
                      strike ===
                      options.reduce((prev, curr) =>
                        Math.abs(curr.strikePrice - underlying) <
                        Math.abs(prev.strikePrice - underlying)
                          ? curr
                          : prev,
                      ).strikePrice;
                    const callPain =
                      underlying > strike ? (underlying - strike) * ceOI : 0;

                    const putPain =
                      strike > underlying ? (strike - underlying) * peOI : 0;

                    // 2️⃣ ITM CALL & PUT logic
                    const isITMCall = strike < underlying; // ITM CALL zone (left)
                    const isITMPut = strike > underlying; // ITM PUT zone (right)

                    //built for call
                    const callbuiltUp = getBuiltUp(
                      item?.CE?.changeinOpenInterest,
                      item.CE?.change,
                    );
                    const putbuiltUp = getBuiltUp(
                      item.PE?.changeinOpenInterest,
                      item.PE?.change,
                    );

                    // --- apply colors ---
                    const rowColor = isATM
                      ? "#cce5ff" // Blue ATM
                      : isITMCall || isITMPut
                        ? "#fff7c6" // Light yellow zone
                        : "transparent"; // Normal row
                    return (
                      <tr key={idx}>
                        <td>
                          <span
                            style={{
                              backgroundColor:
                                item.CE?.openInterest === ceMaxOI
                                  ? "#2fd18a"
                                  : "transparent",
                              fontWeight:
                                item.CE?.openInterest === ceMaxOI
                                  ? "bold"
                                  : "normal",
                              borderRadius: "10px",
                              padding: "1rem",
                            }}
                          >
                            {formatNumber(item.CE?.openInterest) ?? "-"}
                          </span>
                        </td>
                        <td>{item.CE?.changeinOpenInterest ?? "-"}</td>
                        <td>{item.CE?.totalTradedVolume ?? "-"}</td>
                        <td>{item.CE?.impliedVolatility ?? "-"}</td>
                        <td>{item.CE?.lastPrice ?? "-"}</td>
                        <td
                          style={{
                            color:
                              item.CE?.change?.toFixed(2) > 0
                                ? "#2fd18a"
                                : "#ff4d4d",
                          }}
                        >
                          {item.CE?.change?.toFixed(2) ?? "-"}
                        </td>
                        <td style={{ color: getBuiltUpColor(callbuiltUp) }}>
                          {callbuiltUp}
                        </td>
                        <td>{callPain.toFixed(2)}</td>
                        {/* <td>{item.expiryDate}</td> */}
                        <td>
                          <strong>{rowPCR}</strong>
                        </td>
                        <td>
                          <strong style={{ color: "#0047FF" }}>
                            {item.strikePrice}
                          </strong>
                        </td>

                        <td
                          style={{
                            color:
                              item.PE?.change?.toFixed(2) > 0
                                ? "#2fd18a"
                                : "#ff4d4d",
                          }}
                        >
                          {item.PE?.change?.toFixed(2) ?? "-"}
                        </td>
                        <td>{item.PE?.lastPrice ?? "-"}</td>
                        <td>{item.PE?.impliedVolatility ?? "-"}</td>
                        <td>{item.PE?.totalTradedVolume ?? "-"}</td>
                        <td>{item.PE?.changeinOpenInterest ?? "-"}</td>

                        <td>
                          <span
                            style={{
                              backgroundColor:
                                item.PE?.openInterest === peMaxOI
                                  ? "#ff4d4d"
                                  : "transparent",
                              fontWeight:
                                item.PE?.openInterest === peMaxOI
                                  ? "bold"
                                  : "normal",
                              borderRadius: "10px",
                              padding: "1rem",
                            }}
                          >
                            {formatNumber(item.PE?.openInterest) ?? "-"}
                          </span>
                        </td>
                        <td style={{ color: getBuiltUpColor(putbuiltUp) }}>
                          {putbuiltUp}
                        </td>
                        <td>{putPain.toFixed(2)}</td>

                        {/* <td>{(callPain + putPain).toFixed(2)}</td> */}
                      </tr>
                    );
                  })}

                  <tr
                    className="final-row-bottom"
                    // style={{ fontSize: "1.2rem", fontWeight: "700" }}
                  >
                    <td>{formatNumber(ce?.totOI)}</td>
                    <td></td>
                    <td>{ce?.totVol}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{pe?.totVol}</td>
                    <td></td>
                    <td>{formatNumber(pe?.totOI)}</td>
                    <td></td>
                    <td
                      style={{
                        color:
                          toPEOI / totCEOI < 0.5
                            ? "#ff4d4d"
                            : toPEOI / totCEOI > 1.5
                              ? "#2fd18a"
                              : "#e6e6e6",

                        fontWeight: "bold",
                        borderRadius: "6px",
                        padding: "6px",
                        textAlign: "center",
                      }}
                    >
                      {(toPEOI / totCEOI).toFixed(2)}
                    </td>
                    {/* <td
                      style={{
                        color: sentimentTextColor,
                        padding: "8px",
                        fontWeight: "600",
                        borderRadius: "6px",
                        textAlign: "center",
                      }}
                    >
                      {finalPain}
                    </td> */}
                    <td></td>
                  </tr>
                </tbody>
              </table>
              {/* <div className="chart">
                <MaxPainChart
                  processed={options}
                  underlying={underlying}
                  maxPain={maxPain}
                />
              </div> */}
              {/* <div
                className="card"
                style={{
                  padding: "10px",
                  marginTop: "20px",

                  borderRadius: "6px",
                  fontSize: "14px",
                  lineHeight: "1.6",
                }}
              >
                <h1 style={{ color: "white", fontWeight: "800" }}>Note</h1>
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,
                    marginTop: "20px",
                  }}
                >
                  <li style={{ color: "#2fd18a", marginBottom: "6px" }}>
                    <strong>LB</strong> – Long Built-Up (OI ↑ & Price ↑)
                  </li>

                  <li style={{ color: "#ff4d4d", marginBottom: "6px" }}>
                    <strong>SB</strong> – Short Built-Up (OI ↑ & Price ↓)
                  </li>

                  <li style={{ color: "#3b82f6", marginBottom: "6px" }}>
                    <strong>SC</strong> – Short Covering (OI ↓ & Price ↑)
                  </li>

                  <li style={{ color: "#ffa500", marginBottom: "6px" }}>
                    <strong>LW</strong> – Long Unwinding (OI ↓ & Price ↓)
                  </li>
                </ul>
              </div> */}
            </div>
            <div className="chart">
              <MaxPainChart
                processed={options}
                underlying={underlying}
                maxPain={maxPain}
              />
            </div>
          </div>
        )
      )}
    </>
  );
};

export default OptionChain;
